/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { ResourceType } from '../models/ResourceType';

export class BigQueryNativePitrBackupResourceType {
  'resourceType'?: ResourceType & string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "resourceType",
      "baseName": "resourceType",
      "type": "ResourceType & string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return BigQueryNativePitrBackupResourceType.attributeTypeMap;
  }

  public constructor() {
  }
}

